import * as tslib_1 from "tslib";
import { takeLatest, call, all } from 'redux-saga/effects';
import { request } from '../../xhr';
import snakeCase from 'lodash/snakeCase';
import { dropFirstTimeFlag } from './actions';
function dropFlagHandler(action) {
    var _a, flag, redirectTo, result;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                _a = action.payload, flag = _a.flag, redirectTo = _a.redirectTo;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/drop_first_time_flag',
                        data: { flag: snakeCase(flag) },
                    }, function () { return ({
                        success: true,
                    }); })];
            case 1:
                result = _b.sent();
                if (result && result.success && redirectTo) {
                    window.location.href = redirectTo;
                }
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeLatest(dropFirstTimeFlag, dropFlagHandler)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map